/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setInstrumentScope} from '../api'

export const useMutationSetInstrumentScope = createReactQueryMutationHook('setInstrumentScope', setInstrumentScope)
